import React, { useState } from 'react';
import styles from '../../styles/common/PageTitleWithTooltip.module.scss';

interface PageTitleWithTooltipProps {
  title: string;
  description?: string;
  className?: string;
}

function PageTitleWithTooltip({ title, description, className }: PageTitleWithTooltipProps) {
  const [showDescription, setShowDescription] = useState(false);

  if (!description) {
    return <h1 className={className}>{title}</h1>;
  }

  return (
    <div 
      className={styles.titleContainer}
      onMouseEnter={() => setShowDescription(true)}
      onMouseLeave={() => setShowDescription(false)}
    >
      <div className={styles.titleWithIcon}>
        <h1 className={className}>{title}</h1>
        <div className={styles.infoIconContainer}>
          <svg
            className={styles.infoIcon}
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"></path>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
      </div>
      {showDescription && (
        <div className={styles.descriptionContainer}>
          <div className={styles.descriptionText}>
            {description}
          </div>
        </div>
      )}
    </div>
  );
}

export default PageTitleWithTooltip;
